import { PreferencesContext } from "../../contexts/PreferencesContext";
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';

// users
import moment from 'moment';
import { API_URL, URL } from '../../variables';
import { maskNumber } from '../../Auxiliar/Masks';

import ReactPaginate from 'react-paginate';
import { MdDelete, MdFileDownload, MdReply } from 'react-icons/md';
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner } from "react-bootstrap";
import ImageLoaderInput from '../ReusableComponents/ImageLoaderInput';
import Attention from '../ReusableComponents/Attention';
import { RiArrowGoBackLine } from 'react-icons/ri';
import DefaultButton from '../ReusableComponents/DefaultButton';
import JoditEditor from 'jodit-react';
import ModalQuestao from '../CategoriasQuestoes/ModalQuestao';



import { TextField } from '@material-ui/core';
import './label.css';
import { DatePicker, TimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import 'moment/locale/pt-br';
import { alpha } from '@material-ui/core/styles';
import { BsFile, BsFillEyeFill } from 'react-icons/bs';
import BlockSelect from '../BlocosProcesso/BlockSelect';
import TableEmptyState from '../ReusableComponents/TableEmptyState';
class CriarQuestionarioVinculado extends Component {static contextType = PreferencesContext;

  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      path: '/',
      loading_screen: true,
      roles: [],
      name: '',
      enunciado: '',
      msgErroTextoApoio: '',
      loading_save: false,
      msgErro: '',
      loading_image: false,
      inicio: moment(),
      processo: { name: '' },
      arquivos: [],
      texto: '',
      titulo: '',
      texto_value: '',
      questionario_enunciado: '',
      show_autocomplete_questionario: false,
      loading_search_questionario: false,
      questionarios: [],
      questionarios_selecionadas: {},
      showModal: false,
      questionarioSelect: null,
      localizacoes: [
      {
        value: 'avaliacao_nao_iniciada',
        labelKey: "ui_antes_de_iniciar_a_avaliacao_1026e291"
      },
      {
        value: 'avaliacao_andamento',
        labelKey: "ui_durante_a_avaliacao_b2e19d2f"
      },
      {
        value: 'avaliacao_finalizada',
        labelKey: "ui_apos_finalizada_a_avaliacao_4f08017f"
      }],

      where: 'avaliacao_andamento',
      block_id: ''

    };


  }

  get_processo(id) {

    if (this.state.loading_screen == false) {
      this.setState({ loading_screen: true });
    }
    fetch(`${URL}api/faculdade/get_processo/${id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');localStorage.removeItem('user');
          // this.setState({redirect:true,path:'/'});
          this.props.logout();
          return;
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          this.setState({ redirect: true });

          //   setTimeout(()=>{
          //     this.get_processo();
          //   });
        } else
        {
          // this.props.mudarUser(resp.user);

          this.setState({
            loading_screen: false, processo: resp.processo
          });
          // if (resp.processo != null) {


        }




      } catch (err) {
        this.setState({ redirect: true });
        console.log(err);


      }

    }).
    catch((err) => {
      this.setState({ redirect: true });

      console.log(err);
      // this.props.mudarLoadingHome(false);
    });
  }



  salvar(e) {
    e.preventDefault();
    this.setState({ loading_save: true, msgErro: '' });
    let questionarios = [...Object.keys(this.state.questionarios_selecionadas)];

    // for (let i = 0; i < questionarios.length; i++) {
    //     form.append('questionarios[]', JSON.stringify(questionarios[i]);
    // }
    // form.append('processo_id', this.state.processo.id);



    const data = {
      questionarios,
      where: this.state.where,
      processo_id: this.state.processo.id
    };
    if (this.state.processo.has_blocks === true || this.state.processo.has_blocks === 1 || this.state.processo.has_blocks === '1') {
      data.block_id = this.state.block_id || null;
    }

    fetch(`${URL}api/faculdade/store_questionarios_vinculados`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        'Authorization': `Bearer ${this.props.token}`
      },
      body: JSON.stringify(data)
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          window.scrollTo(500, 0);

          this.setState({ loading_save: false, msgErro: erro });
        } else
        {

          this.setState({ loading_save: false, redirect: true });

        }




      } catch (err) {
        console.log(err);
        this.setState({ loading_save: false, msgErro: 'Erro ao pegar resposta do servidor' });

      }

    }).
    catch((err) => {
      console.log(err);
      this.setState({ loading_save: false, msgErro: 'Erro ao pegar resposta do servidor. Você está conectado a internet?' });
    });
  }


  componentDidMount() {
    this.get_processo(this.props.match.params.id);
  }

  get_questionario_search(search) {
    if (this.state.loading_search_questionario == false) {
      this.setState({ loading_search_questionario: true });
    }
    fetch(`${URL}api/faculdade/get_questionarios_nao_vinculados_search/${this.state.processo.id}?page=1&search=${search}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');
          // this.setState({redirect:true,path:'/'});
          this.props.logout();
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          // this.setState({ redirect: true });
          this.setState({ loading_search_questionario: false });

          //   setTimeout(()=>{
          //     this.get_processo();
          //   });
        } else
        {
          // this.props.mudarUser(resp.user);
          this.setState({ loading_search_questionario: false, questionarios: resp.questionarios });
          // if (resp.processo != null) {


        }




      } catch (err) {
        this.setState({ loading_search_questionario: false });
        console.log(err);


      }

    }).
    catch((err) => {
      this.setState({ loading_search_questionario: false });

      console.log(err);
      // this.props.mudarLoadingHome(false);
    });
  }


  select_questionario(item) {
    let questionarios = { ...this.state.questionarios_selecionadas };
    questionarios[item.id] = item;
    this.setState({ questionario_enunciado: '', questionarios_selecionadas: questionarios });
  }


  change_tipo(event) {
    this.setState({ tipo: event.target.value });
  }


  render() {
    return (
      <div className="row">
                {this.state.redirect == true && <Redirect to={`/processos/show/${this.props.match.params.id}?tab=3`} />}

                <div className="col-12">
                    <div className="card">
                        <div className="card-body" id="card" style={{ overflow: 'visible' }}>

                            <div hidden id="text_enunciado">

                            </div>
                            <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>{this.context.t("ui_vincular_questionario_s_0c995c4c")}</h4>
                            <p style={{ fontSize: '1rem', color: 'black' }}>{this.context.t("ui_vincule_um_ou_mais_questionarios_ao_processo_a186a3eb")}{this.state.processo.name}</p>
                            <br />


                            {/* <hr /> */}
                            {this.state.loading_screen == false && <div>
                                {this.state.msgErro != '' && <div style={{ display: 'flex', marginBottom: 15, width: '100%' }}>
                                    <div className="badge badge-danger error-message-badge error-message-badge-dismissible w-100" role="alert">
                                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => this.setState({ msgErro: '' })}></button>


                                        <p style={{ marginBottom: 0 }}>{this.state.msgErro}</p>

                                    </div>
                                    <br />

                                </div>}
                                <Form onSubmit={(e) => this.salvar(e)} style={{ position: "relative" }}>

                                    {/* <h5 style={{ fontWeight: 'bold' }}>Candidatos</h5>
                    <br /> */}
                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{this.context.t("ui_onde_o_questionario_ira_aparecer_be82f196")}<Attention /></Form.Label>

                                            <select disabled className="form-select " onChange={(e) => {
                        this.setState({ where: e.target.value });
                      }} value={this.state.where}>
                                                {this.state.localizacoes && this.state.localizacoes.length != 0 && this.state.localizacoes.map((value, index) =>
                        <option
                          key={index}
                          value={value["value"]}>
                          {this.context.t(value["labelKey"])}</option>
                        )}
                                            </select>

                                        </div>

                                    </InputGroup>
                                    <BlockSelect
                    processo={this.state.processo}
                    token={this.props.token}
                    value={this.state.block_id}
                    onChange={(block_id) => this.setState({ block_id })} />


                                    {<InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{`${this.context.t("legacy_busque_um_ou_mais_questionarios_que_deseja_vincular")} `}</Form.Label>
                                            <Input
                        placeholder={this.context.t("ui_pesquise_o_questionario_pelo_nome_ab3d430c")}
                        value={this.state.questionario_enunciado}
                        // onChange={(e) => this.setState({ questionario_enunciado: e.target.value })}
                        onBlur={() => {
                          this.timeout_ = setTimeout(() => {
                            this.setState({ show_autocomplete_questionario: false });

                          }, 500);
                        }}
                        onFocus={() => {
                          clearTimeout(this.timeout_);
                          this.setState({ show_autocomplete_questionario: true });
                        }}
                        onChange={(e) => {this.get_questionario_search(e.target.value);this.setState({ questionario_enunciado: e.target.value });}}
                        // title="Coloque o nome completo do usuário"
                      />
                                            {this.state.show_autocomplete_questionario == true && this.state.questionario_enunciado != '' && <div className="overflow-auto" style={{ width: '100%', position: 'absolute', zIndex: 20, backgroundColor: 'white', border: '1px solid lightgrey', borderRadius: '5px', maxHeight: '50vh', top: 70 }}>
                                                {this.state.loading_search_questionario == false && this.state.questionarios.map((item, id) =>
                        <div key={id} onClick={() => {
                          let questionarios_selecionadas = { ...this.state.questionarios_selecionadas };
                          questionarios_selecionadas[item.id] = item;
                          this.setState({ questionarios_selecionadas, showModal: true, show_autocomplete_questionario: false });
                          // this.select_questionario(item);
                        }} className="opcao_autocomplete">
                                                        <b>{item.name}</b> - {item.questoes.length} {item.questoes.length == 1 ? this.context.t("question") : this.context.t("questions")}
                                                    </div>
                        )}
                                                {this.state.loading_search_questionario == false && this.state.questionarios.length == 0 &&
                        <div className="opcao_autocomplete">{this.context.t("ui_nenhum_questionario_encontrado_com_este_termo_a4b1cd9f")}

                        </div>
                        }
                                                {this.state.loading_search_questionario == true &&
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                                        <div className="spinner-border text-primary" role="status">
                                                        </div></div>}
                                            </div>}
                                        </div>
                                    </InputGroup>}



                                    <Form.Label>{this.context.t("ui_questionarios_selecionados_6a604e81")}<Attention /></Form.Label>

                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <div className="table-modern-card">
                                                <div className="table-modern-scroll mb-0">
                                                    <table id="tech-companies-1" className="table table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th>{this.context.t("label_name")}</th>
                                                                <th>{this.context.t("legacy_numero_de_questoes")}</th>

                                                                <th data-priority="3">{this.context.t("label_actions")}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {Object.values(this.state.questionarios_selecionadas).map((item, id) =>
                              <tr key={id}>
                                                                    <td>{item.name}</td>
                                                                    <td>{item.questoes.length}</td>
                                                                    {/* <td><img style={{ height: 60, width: 60, objectFit: 'contain' }} src={STORAGE_URL + STORAGE_URL + item.arquivo} /></td> */}

                                                                    <td>
                                                                        <div className="actions-group">
                                                                        {/* <span
                                    onClick={() => {
                                    this.setState({ questionarioSelect: item, showModal: true });
                                    }}
                                    className="inline-flex align-center jcc bg-warning icon"
                                    style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                    title="Gerenciar aula"
                                    >
                                    <BsFillEyeFill size={17} color="white" />
                                    </span> */}
                                                                        <span
                                    onClick={(e) => {

                                      let questionarios_selecionadas = { ...this.state.questionarios_selecionadas };
                                      delete questionarios_selecionadas[item.id];
                                      this.setState({ questionarios_selecionadas });
                                    }}
                                    className="inline-flex align-center jcc bg-danger icon"
                                    style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                    title={this.context.t("ui_desvincular_questionario_ac6d9747")}>

                                                                            <MdDelete size={17} color="white" />
                                                                        </span>

                                                                        </div>
                                                                        </td>

                                                                </tr>
                              )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            {Object.values(this.state.questionarios_selecionadas).length == 0 && <div className="row">
                                                <div className="col-12">
                                                    <TableEmptyState title={this.context.t("ui_nenhum_questionario_selecionado_d6a1afb8")} icon="📋" />

                                                </div>
                                            </div>}
                                        </div>

                                    </InputGroup>


                                    {this.state.loading_save == false && <div className="w100 inline-flex jcsb margin-top-1">
                                        {/* <Link to={`/accounts/list`}>
                      <Button variant="secondary"><RiArrowGoBackLine/> Voltar</Button>
                      </Link> */}
                                        <DefaultButton
                      bg="secondary"
                      text={this.context.t("back")}
                      icon={<RiArrowGoBackLine />}
                      search={'?tab=3'}
                      to={`/processos/show/${this.props.match.params.id}`} />

                                        {/* <Button variant="success" type="submit" disabled={this.loading}>
                      {this.state.loading ? <Spinner /> : ""}
                      Registrar usuário
                      </Button> */}
                                        <DefaultButton
                      type="submit"
                      bg="confirm"
                      text={this.context.t("legacy_salvar_questionarios")}
                      disabled={this.state.loading_image == true}
                      loadingtext={this.context.t("ui_salvando_questionarios_0ee57d98")}
                      loading={this.state.loading_save} />

                                    </div>}

                                    {this.state.loading_save == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center margin-top-1">
                                        <div className="spinner-border text-primary" role="status">
                                        </div>
                                    </div></div>}
                                </Form>

                            </div>}

                            {this.state.loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                                <div className="spinner-border text-primary" role="status">
                                </div>
                            </div></div>}


                        </div>

                    </div>
                </div>
            </div>);

  }


}
const mapsStateToProps = (state) => (
{
  token: state.AppReducer.token
});


export default connect(mapsStateToProps, { logout })(CriarQuestionarioVinculado);
